// extracted by mini-css-extract-plugin
export var errorIcon = "_ll-1";
export var nameLogo = "_ll-0";